import { jsx as r, Fragment as n } from "react/jsx-runtime";
import { Overlay as m } from "./style.js";
import { createPortal as i } from "react-dom";
import { getOrCreatePortalElement as p } from "../../../../services/runtime/index.js";
import { DROPDOWN_PORTAL_ID as a } from "../../consts.js";
import { useDropdownContext as f } from "../../../../contexts/Dropdown/context.js";
function c({
  hideOnDesktop: o = !1,
  ...t
}) {
  const { isOpen: e } = f();
  return e ? /* @__PURE__ */ r(n, { children: i(
    /* @__PURE__ */ r(m, { "data-not-hide-on-desktop": !o, ...t }),
    p(a)
  ) }) : null;
}
export {
  c as DropdownOverlay
};
